import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="surfacing-students-tab"
export default class extends Controller {
  static targets = ["criteriaType"]
  connect() {
    super.connect()
  }

  criteriaTypeTargetConnected(element) {
  }
  criteriaTypeTargetDisconnected(element) {
  } 

  changeSurface({ target }) {  
    this.criteriaTypeTarget.value = null
  }
}
